<script setup lang="ts">
defineProps<{ chapter: string; index?: number | string | undefined | null }>()

// ------- GSAP ANIMATION -------
const { $gsap, $ScrollTrigger } = useNuxtApp()
const chapterEl = ref<HTMLElement | null>(null)
const randomId = Math.random().toString(36).slice(2)

async function cleanupAnimation(): Promise<void> {
  $ScrollTrigger.getById('chapterReveal' + randomId)?.kill()

  if (chapterEl.value) {
    $gsap.set(chapterEl.value, { clearProps: 'all' })
  }

  await Promise.resolve()
}

async function initAnimation() {
  if (!chapterEl.value) return
  $gsap.fromTo(
    chapterEl.value,
    {
      clipPath: 'polygon(-100% 0%, 0% 0%, -05% 100%, -100% 100%)',
    },
    {
      clipPath: 'polygon(-100% 0%, 105% 0%, 100% 100%, -100% 100%)',
      scrollTrigger: {
        id: 'chapterReveal' + randomId,
        trigger: chapterEl.value,
        // markers: true,
        start: `top 90%`,
        end: `bottom top`,
        toggleActions: 'play reverse play reverse',
      },
    },
  )
}

onMounted(async () => {
  await nextTick()
  await cleanupAnimation()
  await initAnimation()
})

onBeforeUnmount(async () => {
  await cleanupAnimation()
})
</script>

<template>
  <h2
    v-if="index"
    ref="chapterEl"
    class="page-chapter inline-flex gap-2 font-mono text-sm uppercase"
  >
    <span class="chapter-index">[{{ zeroPad(index) }}]</span><span>{{ chapter }}</span>
  </h2>
</template>
